$('#contact_form button').on('click', function(e){
    e.preventDefault();
    var btn = $(this);
    btn.addClass('is-loading');
    $('#contact_form input').removeClass('is-danger');
    $('#contact_form textarea').removeClass('is-danger');
    $('#contact_error').html('');
    $('#contact_error').addClass('is-hidden');
    axios.post('', $('#contact_form').serialize())
    .then(function(response){
        btn.removeClass('is-loading');
        $('#contact_form').addClass('is-hidden');
        $('#contact_ok_msg').removeClass('is-hidden');
    })
    .catch(function(error){
        btn.removeClass('is-loading');
        $('#contact_error').removeClass('is-hidden');
        
        for(key in error.response.data.errors) {
            $('#contact_form input[name="'+key+'"]').addClass('is-danger');
            $('#contact_form textarea[name="'+key+'"]').addClass('is-danger');
        }
        if(Object.keys(error.response.data.errors).length == 1 && error.response.data.errors['email']) {
            $('#contact_error').append(error.response.data.errors['email']);
        } else if(Object.keys(error.response.data.errors).length > 1) {
            $('#contact_error').append($('#contact_form input[name="general_error"]').val());
        }

    });
});
